import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-returndate-history',
  templateUrl: './fes-workflow-action-returndate-history.component.html',
  styleUrls: ['./fes-workflow-action-returndate-history.component.scss']
})
export class FesWorkflowActionReturndateHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
